import { render, staticRenderFns } from "./DialogItemBody.vue?vue&type=template&id=7c97f11e&"
import script from "./DialogItemBody.vue?vue&type=script&lang=js&"
export * from "./DialogItemBody.vue?vue&type=script&lang=js&"
import style0 from "./DialogItemBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports